import React, { useEffect, useRef, useState } from 'react';

const ScrollReveal = ({ children, direction = 'up', delay = 0, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const baseStyles = {
    transition: `opacity 0.7s cubic-bezier(0.16,1,0.3,1) ${delay}s, transform 0.7s cubic-bezier(0.16,1,0.3,1) ${delay}s`,
    opacity: isVisible ? 1 : 0,
    willChange: 'opacity, transform'
  };

  const transforms = {
    up: isVisible ? 'translateY(0)' : 'translateY(40px)',
    down: isVisible ? 'translateY(0)' : 'translateY(-40px)',
    left: isVisible ? 'translateX(0)' : 'translateX(40px)',
    right: isVisible ? 'translateX(0)' : 'translateX(-40px)',
    scale: isVisible ? 'scale(1)' : 'scale(0.95)',
    none: 'none'
  };

  return (
    <div
      ref={ref}
      className={className}
      style={{ ...baseStyles, transform: transforms[direction] || transforms.up }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
